import {Routes} from '@angular/router';
import {LoggedinComponent} from './loggedin/loggedin.component';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './loggedin/dashboard/dashboard.component';
import {CustomersComponent} from './loggedin/customers/customers.component';
import {AuthGuard} from '../services/auth-guard';
import {CalendarComponent} from './loggedin/calendar/calendar.component';
import {CustomerDetailComponent} from './loggedin/customer-detail/customer-detail.component';
import {PetDetailComponent} from './loggedin/pet-detail/pet-detail.component';
import {CreateCustomerComponent} from './loggedin/create-customer/create-customer.component';
import {CreatePetComponent} from './loggedin/create-pet/create-pet.component';
import {CreateTreatmentComponent} from './loggedin/create-treatment/create-treatment.component';
import {PictureDrawerComponent} from './loggedin/picture-drawer/picture-drawer.component';
import {PdfViewerComponent} from './loggedin/pdf-viewer/pdf-viewer.component';
import {TreatmentDetailComponent} from './loggedin/treatment-detail/treatment-detail.component';
import {EditCustomerComponent} from './loggedin/edit-customer/edit-customer.component';
import {EditPetComponent} from './loggedin/edit-pet/edit-pet.component';
import {EditTreatmentComponent} from './loggedin/edit-treatment/edit-treatment.component';
import {SettingsComponent} from './loggedin/settings/settings.component';

export const routes: Routes = [
  {
    path: "loggedin", component: LoggedinComponent, canActivate: [AuthGuard],
    children: [
      {path: "dashboard", component: DashboardComponent},
      {path: "customers", component: CustomersComponent},
      {path: "settings", component: SettingsComponent},
      {path: "customers/create", component: CreateCustomerComponent},
      {path: "customers/edit/:customerId", component: EditCustomerComponent},
      {path: "calendar", component: CalendarComponent},
      {path: "customer-detail/:customerId", component: CustomerDetailComponent},
      {path: "pet-detail/:petId", component: PetDetailComponent},
      {path: "pets/create", component: CreatePetComponent},
      {path: "pets/edit/:petId", component: EditPetComponent},
      {path: "treatments/create", component: CreateTreatmentComponent},
      {path: "treatments/edit/:treatmentId", component: EditTreatmentComponent},
      {path: "images/annotate", component: PictureDrawerComponent},
      {path: "show-pdf", component: PdfViewerComponent},
      {path: "treatment-detail/:treatmentId", component: TreatmentDetailComponent},
    ]
  },
  {path: "**", component: LoginComponent, canActivate: [AuthGuard],}
];
